import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function Watermark({ position = "right" }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-60, 60]);
  const align = position === "left" ? "justify-start" : "justify-end";
  const offset = position === "left" ? "ml-[-6%]" : "mr-[-6%]";

  return (
    <div
      ref={ref}
      aria-hidden="true"
      data-testid="brand-watermark"
      className={`pointer-events-none absolute inset-0 overflow-hidden flex items-center ${align}`}
    >
      <motion.img
        src="/favicon.png"
        alt=""
        style={{ y }}
        className={`w-[75%] max-w-[950px] ${offset} opacity-[0.04] grayscale select-none`}
      />
    </div>
  );
}
